import BaseAbility from 'umg-ember-backend/abilities/base';

export default class TaxonAbility extends BaseAbility {}
